import React from "react";

const Header = () => {
  return (
    <header>
      <h1>Welcome to happy thoughts!</h1>
    </header>
  );
};

export default Header;
